module.exports = __webpack_public_path__ + "img/header-2.3f9893c2.svg";